import classNames from 'classnames';

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  noScroll?: boolean;
  children: React.ReactNode;
  className: string;
}

export const Box = ({
  noScroll = true,
  children,
  className,
  ...rest
}: BoxProps) => (
  <div
    className={classNames(className, {
      'overflow-hidden': noScroll,
    })}
    {...rest}
  >
    {children}
  </div>
);
